import { useMutation } from '@tanstack/react-query';
import { useLocation } from 'react-router';

import { useApi } from 'services/api';
import { usePqlActions } from 'services/search';
import { parseQueryString } from 'utils/url';
import { PAGES } from 'consts/pages';

type SetEventStatusParams = {
  record: Record<string, unknown> & {
    tenantId: string;
    eventId: string;
    status?: string;
  };
  status: string;
};

export const useSetEventStatus = () => {
  const api = useApi();
  const location = useLocation();
  const { triggerPqlQuery } = usePqlActions(PAGES.events);

  const forceTriggerPql = () => {
    const qs = parseQueryString(location.search);
    const query = Array.isArray(qs.q) ? qs.q[0] : qs.q;
    if (query && typeof query === 'string') {
      triggerPqlQuery(query, true);
    }
  };

  return useMutation({
    mutationFn: async ({ record, status }: SetEventStatusParams) => {
      return api.post(`/tenants/${record.tenantId}/events/${record.eventId}/status/${status}`);
    },
    onSuccess: () => {
      forceTriggerPql();
    },
  });
};
